import React from "react";
import { Link } from "react-router-dom";

export default function Error(){
    return(
        <>
        <section className="error-area">
            <div className="container">
                <div className="row justify-content-center text-center">
                    <div className="col-md-12 col-lg-8">
                        <div className="error-box">
                            <img src="/assets/images/404Error.webp" alt="Error" />
                            <h1 className="heading">This Page took a Wrong Turn</h1>
                            <p>The page you’re looking for isn’t available right now. Please return to the homepage or explore our laundry solutions and products.</p>
                            
                              <div className="btn-sec">
                                    <Link to={"/"}className="default-btn">
                                        <span>go to homepage</span>
                                    </Link>
                                </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>
        </>
    )
}